import { BehaviorSubject } from 'rxjs';

const sportEventRulesModal$ = new BehaviorSubject(false);
const winnerListModal$ = new BehaviorSubject(false);

const displaySportEventRulesModal = (isShow: boolean) => {
	sportEventRulesModal$.next(isShow);
};

const displayWinnerListModal = (isShow: boolean) => {
	winnerListModal$.next(isShow);
};

export const sportEventModalService = {
	sportEventRulesModal$: sportEventRulesModal$.asObservable(),
	displaySportEventRulesModal,
	winnerListModal$: winnerListModal$.asObservable(),
	displayWinnerListModal,
}; 